import '../../../common/dashboard/filters/filter.js.coffee'

Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.AssignedAdvisorFilter extends Common.Dashboard.Filters.Filter

  @FILTER_TYPE: 'assigned_advisor'
  @HUMAN_FILTER_TYPE: 'human'
  @ROBOT_FILTER_TYPE: 'robot'
  @NOBODY_FILTER_TYPE: 'nobody'
  @ROBOT_ID: 'robot'
  @NOBODY_ID: 'nobody'
  removable: true

  constructor: ({values}) ->
    super(values: values)

  getFilterType: ->
    @constructor.FILTER_TYPE

  getValues: (advisors) ->
    values = []
    if @_humanAdvisors(advisors)
      values = ([].concat({id: humanAdvisor.id, name: humanAdvisor.name} for humanAdvisor in @_humanAdvisors(advisors)))
    values = values.concat({id: @constructor.ROBOT_ID, name: 'Robot', icon: 'robot-icon'}) if @_robotAdvisor()
    if @_noAssignation()
      values = values.concat({id: @constructor.NOBODY_ID, name: @_nobodyAssignedLabel(), icon: 'unassigned-icon'})
    values

  _humanAdvisors: (advisors) ->
    return null unless advisors
    humanIDs = @_humanAdvisorsIDs()
    assignedAdvisors = _.filter advisors, (advisor) ->
      advisor.get('user').id in humanIDs
    assignedAdvisors.map (advisor) =>
      advisorUser = advisor.get('user')
      {
        id: advisorUser.id,
        name: @_displayAdvisorName(advisorUser)
      }

  _humanAdvisorsIDs: ->
    @_valuesByType(@constructor.HUMAN_FILTER_TYPE)?.ids || []

  _robotAdvisor: ->
    @_valuesByType(@constructor.ROBOT_FILTER_TYPE)

  _noAssignation: ->
    @_valuesByType(@constructor.NOBODY_FILTER_TYPE)

  _valuesByType: (type) ->
    _.findWhere(@values, type: type)

  removeValue: (valueToRemove) ->
    switch valueToRemove.id
      when @constructor.NOBODY_ID then @_removeValueType @constructor.NOBODY_FILTER_TYPE
      when @constructor.ROBOT_ID then @_removeValueType @constructor.ROBOT_FILTER_TYPE
      else @_removeHumanValue(valueToRemove.id)

  _removeHumanValue: (valueID) ->
    humanIDs = @_humanAdvisorsIDs()
    humanIDs.splice(humanIDs.indexOf(valueID), 1)
    @_removeValueType(@constructor.HUMAN_FILTER_TYPE) unless humanIDs.length

  _removeValueType: (valueType) ->
    @values = _.reject(@values, (value) -> value.type == valueType)

  hasValues: ->
    @values.length != 0

  _valuesToJSON: ->
    @values

  _nobodyAssignedLabel: ->
    I18n.t('customer.dashboard.conversations.details.assign.nobody')

  _displayAdvisorName: (advisorUser) ->
    "#{advisorUser.last_name}, #{advisorUser.first_name} (#{advisorUser.email})"
